import React, { useState } from 'react';
import { Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import AuthButton from '../auth-button';

const UploaderDoc = ({
  finishUpload = () => {},
  envUrl,
  btnName,
  authCode = '',
  className = '',
  disbaleFileList = false,
  finishRemove = () => {},
  onError = () => {},
  beforeUpload = () => {},
}) => {
  const [fileList, setFileList] = useState([]);

  const uploadProps = {
    name: 'file',
    action: envUrl,
    accept: '.xls,.xlt,.xlsx,.csv',
    withCredentials: true,
    fileList,
    beforeUpload,
    onChange: info => {
      if (info.file.status === 'done') {
        if (info.file.response.flag === 200) {
          let msg = `${info.file.name} 上传成功！`;

          if (typeof info.file.response.data === 'string') {
            msg += info.file.response.data;
          }
          message.success(msg);

          finishUpload(info.file.response.data || {});
          !disbaleFileList && setFileList([info.file]);
        } else {
          if (info.file.response.flag !== 410) {
            message.error(info.file.response.msg);
          }
          onError(info.file.response);
        }
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 上传失败.`);
      }
    },
    onRemove: () => {
      setFileList([]);
      finishRemove();
    },
  };

  return (
    <Upload {...uploadProps}>
      <AuthButton className={className} authCode={authCode} icon={<UploadOutlined />}>
        {btnName}
      </AuthButton>
    </Upload>
  );
};

export default UploaderDoc;
